module.exports = __webpack_public_path__ + "static/media/gmes-africa-logo.6c0803de.png";